import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface DepositoData {
  id: number;
  descripcion: string;
}

const EditarDepositos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    const fetchDeposito = async () => {
      if (!id) return;
      
      console.log('fetchDeposito id:', id);
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_depositos/${id}`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Error al cargar el deposito');
        }

        const data = await response.json();
        console.log('datos recibidos:', data);
        
        form.setFieldsValue({
          descripcion: data.descripcion,
        });
      } catch (error) {
        console.error('Error:', error);
        message.error('Error al cargar los datos del deposito');
      }
    };

    fetchDeposito();
  }, [id, form, getAccessTokenSilently]);

  const onFinish = async (values: any) => {
    if (!id) return;
    
    setButtonLoading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/editar_depositos/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el deposito');
      }

      message.success('Deposito actualizado correctamente');
      navigate('/listar_depositos');
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el deposito');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ maxWidth: 600, margin: '20px auto' }}
    >
      <Form.Item
        name="descripcion"
        label="Descripción"
        rules={[{ required: true, message: 'Por favor ingrese la descripción' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <Button 
        type="primary"
         htmlType="submit" 
         loading={buttonLoading}
         disabled={buttonLoading}
         >
          {buttonLoading ? 'Actualizando...' : 'Actualizar'}
        </Button>
        <Button 
          style={{ marginLeft: 8 }} 
          onClick={() => navigate('/listar_depositos')}
        >
          Listar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default EditarDepositos;